<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Thời Khóa Biểu" :link="[{ text: 'Thời khóa biểu', href: '../time-table-config' }]" />
      </div>
      <div v-if="$auth.policies['config-class-schedule']">
        <v-btn depressed dark color="#0D47A1" @click.stop="createState = !createState">
          <v-icon left>add</v-icon>Xếp thời khóa biểu
        </v-btn>
      </div>
    </div>
    <v-tabs class="mx-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card class="mx-4 elevation-0" outlined>
      <div :flat="$vuetify.breakpoint.smAndDown">
        <v-tabs-items v-model="tab" v-if="getTabPolicies === 'both'">
          <v-tab-item :key="1">
            <ClassTimeTable />
          </v-tab-item>
          <v-tab-item :key="2">
            <TeacherTimeTable />
          </v-tab-item>
        </v-tabs-items>

        <v-tabs-items v-model="tab" v-else-if="getTabPolicies === 'class'">
          <v-tab-item :key="1">
            <ClassTimeTable />
          </v-tab-item>
        </v-tabs-items>

        <v-tabs-items v-model="tab" v-else>
          <v-tab-item :key="2">
            <TeacherTimeTable />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>

    <TimeTableNewDialog :state="createState" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { get } from 'lodash'
import TimeTableNewDialog from '@/modules/timeTable/TimeTableNewDialog.vue'
import ClassTimeTable from '@/modules/timeTable/ClassTimeTable.vue'
import TeacherTimeTable from '@/modules/timeTable/TeacherTimeTable.vue'

export default {
  components: {
    Breadcrumbs,
    TimeTableNewDialog,
    ClassTimeTable,
    TeacherTimeTable
  },
  data() {
    return {
      grade: null,
      dialog: false,
      selected: null,
      classData: null,
      tab: null,
      teacher: null,
      selectedClassFromTeacher: '',
      selectedClassFromClass: '',
      createState: false
    }
  },
  computed: {
    ...mapState('timeTable', ['classSlots', 'teacherSlots', 'selectedClassId', 'selectedTeacherId']),

    gradeId() {
      return { grade: get(this.grade, 'id') }
    },

    getTabPolicies() {
      if (this.$auth.policies['view-class-schedule'] && this.$auth.policies['view-teacher-schedule']) {
        return 'both'
      } else if (this.$auth.policies['view-class-schedule']) {
        return 'class'
      } else if (this.$auth.policies['view-teacher-schedule']) {
        return 'teacher'
      }
      return ''
    },
    getTabs() {
      if (this.$auth.policies['view-class-schedule'] && this.$auth.policies['view-teacher-schedule']) {
        return ['Lớp học', 'Giáo viên']
      } else if (this.$auth.policies['view-class-schedule']) {
        return ['Lớp học']
      } else if (this.$auth.policies['view-teacher-schedule']) {
        return ['Giáo viên']
      }
      return []
    }
  },
  methods: {
    ...mapActions('timeTable', ['fetchClassSlots', 'fetchTeacherSlots', 'removeSlot'])
  }
}
</script>
<style lang="scss" scoped>
.fullHeight {
  height: 100%;
}
</style>
